import { render } from "./Startlistscreen.vue?vue&type=template&id=59feeb6a&scoped=true"
import script from "./Startlistscreen.vue?vue&type=script&lang=js"
export * from "./Startlistscreen.vue?vue&type=script&lang=js"

import "./Startlistscreen.vue?vue&type=style&index=0&id=59feeb6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59feeb6a"]])

export default __exports__